/**
 * NavbarLabel Component
 *
 * Common text styling component for navbar item labels
 * Follows Single Responsibility Principle
 */

import React from 'react';

export interface NavbarLabelProps {
  children: React.ReactNode;
  className?: string;
  textAlign?: 'center' | 'left' | 'right';
  fontWeight?: number | string;
  style?: React.CSSProperties;
}

export const NavbarLabel: React.FC<NavbarLabelProps> = ({
  children,
  className = '',
  textAlign = 'center',
  fontWeight = 400,
  style = {},
}) => {
  return (
    <span
      className={className}
      style={{
        color: 'var(--Colors-Typography-primary, #1C1917)',
        textAlign,
        fontFamily: 'var(--Typography-Fonts-Primary, Gantari)',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight,
        lineHeight: 'normal',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {children}
    </span>
  );
};
